import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AnalyticsContextService } from '@core/insights/analytics-context.service';

@Injectable()
export class CorrelationInterceptor implements HttpInterceptor {
  public constructor(private analyticsContext: AnalyticsContextService) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const correlationId = this.analyticsContext.getProperties()['correlation_id'];

    if (
      !environment.apiConfig.enableCorrelationHeader ||
      !this.isEligibleApiRequest(req.url) ||
      req.headers.has('X-Correlation-ID') ||
      typeof correlationId !== 'string' ||
      correlationId.length === 0
    ) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: { 'X-Correlation-ID': correlationId },
      }),
    );
  }

  private isEligibleApiRequest(url: string): boolean {
    const requestUrl = this.parseUrl(url);
    if (!requestUrl) return false;

    return Object.entries(environment.apiConfig).some(([key, value]) => {
      if (!key.endsWith('ApiUrl') || typeof value !== 'string') return false;

      const apiUrl = this.parseUrl(value);
      if (!apiUrl || requestUrl.origin.toLowerCase() !== apiUrl.origin.toLowerCase()) return false;

      const apiPath = apiUrl.pathname.replace(/\/+$/, '');
      const requestPath = requestUrl.pathname.replace(/\/+$/, '');
      return requestPath === apiPath || requestPath.startsWith(`${apiPath}/`);
    });
  }

  private parseUrl(url: string): URL | null {
    try {
      return new URL(url, window.location.origin);
    } catch {
      return null;
    }
  }
}
